import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageAttachment } from '@/api/model/interfaces';

export default class DrawingPackageAttachmentOdata extends OdataManager<DrawingPackageAttachment> {}
